import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

export const Advert = ({headline, text, btnUrl, btnText, btnIcon}) => {
    const intl = useIntl();
    return (
        <aside className="card bg-info mb-3">
            <div className="card-body">
                <h5 className="card-title"><FormattedMessage id={headline} /></h5>
                <p className="card-text lead"><FormattedMessage id={text} values={{br:<br/>}} /></p>
            </div>
            <div className="card-footer">
                <a className={"btn btn-primary btn-lg " + btnIcon} href={intl.formatMessage({id: btnUrl})} target="_blank" role="button" rel="noopener noreferrer">
                    <FormattedMessage id={btnText} />
                </a>
            </div>
        </aside>
    );
};